import { forwardRef } from 'react'

export type TextInputProps = React.HTMLProps<HTMLInputElement> & {
  className?: string
  label?: string
  labelClassName?: string
  inputClassName?: string
  error?: string | undefined
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ type = 'text', className, label, labelClassName, inputClassName, error, ...props }, ref) => {
    return (
      <div className={`flex flex-col gap-y-2 ${className ? className : ''}`}>
        {label && (
          <span className={`text-white text-sm font-semibold ${labelClassName ? labelClassName : ''}`}>{label}</span>
        )}
        <div>
          <input
            ref={ref}
            type={type}
            {...props}
            className={`p-3 text-sm md:p-[17px] rounded-full w-full focus:outline-none text-navy-900 
              border border-navy-900 border-opacity-20 ${inputClassName ? inputClassName : ''}`}
          />
        </div>
        {error && <div className="text-boldOrange -mt-1 font-medium">{error}</div>}
      </div>
    )
  }
)
